import x01 from './definition.js';
import { createX01GameController } from '../shared/x01-game-controller.js';

export default createX01GameController(x01);
